import toast from 'react-hot-toast';
import { isViewerOnly } from './admin-permissions';

export const VIEWER_FORBIDDEN_MESSAGE =
  'Tài khoản chỉ xem, không thực hiện được thao tác này.';
export const VIEWER_BANNER_MESSAGE =
  'Bạn đang dùng tài khoản chỉ xem. Không thực hiện được thao tác, dữ liệu cá nhân đã được che.';

// Trả true (đã báo) khi người dùng chỉ xem gặp 403. Gọi trong ngữ cảnh admin.
export const notifyViewerForbidden = (status?: number): boolean => {
  if (status !== 403 || !isViewerOnly()) return false;
  toast.error(VIEWER_FORBIDDEN_MESSAGE, { id: 'viewer-forbidden' });
  return true;
};
